<div class="listingFacet -framesSize" [ngClass]="{'-open': contentVisible}">
  <header class="listingFacet_header">
    <button class="listingFacet_showButton flaticon-down-arrow" (click)="toggleContentVisibility()" type="button">
      {{'filter.panel.sizes.title' | translate}}</button>
  </header>
  <div class="listingFacet_content">
    <div class="sizeFilterPanel">
      <div class="sizeFilterPanel_slideContainer" [ngClass]="{'sizeFilterPanel_slideContainer-frame': activePanel === 'frame'}">
        <div class="sizeFilterPanel_slide sizeFilterPanel_slide-noseLenseWidth">
            <figure>
              <img [src]="themePath+'/images/'+lensesImg" />
            </figure>
            <div class="sizeFilterPanel_fieldset">
              <div class="sizeFilterPanel_input">
                <input type="text" id="input-lences" (change)="validateNoseLense($event.target)" [(ngModel)]="lense" [disabled]="!lensesName || !lensesValues.length" maxlength="2" inputmode="numeric" pattern="[0-9]*" digitOnly>
                <label for="input-frames" [innerHTML]="'filter.panel.sizes.lense.width' | translate"></label>
                <p class="error-message" *ngIf="errorNoseLense">{{'filter.panel.sizes.error.msg' | translate}}</p>
              </div>
              <div class="sizeFilterPanel_input">
                <input type="text" id="input-spectre" (change)="validateNoseLense($event.target)" [(ngModel)]="nose" maxlength="2" [disabled]="!noseName || !noseValues.length" inputmode="numeric" pattern="[0-9]*" digitOnly>
                <label for="input-frames" [innerHTML]="'filter.panel.sizes.nose.width' | translate"></label>
                <p class="error-message" *ngIf="errorNoseLense">{{'filter.panel.sizes.error.msg' | translate}}</p>
              </div>
            </div>
          </div>
          <div class="sizeFilterPanel_slide sizeFilterPanel_slide-frameWidth">
            <figure>
              <img [src]="themePath+'/images/'+framesImg" />
            </figure>
            <div class="sizeFilterPanel_input">
              <input type="text" id="input-frames" [(ngModel)]="frame" (change)="validateFrame($event.target)" [disabled]="!framesName || !framesValues.length" maxlength="3" inputmode="numeric" pattern="[0-9]*" digitOnly>
              <label for="input-frames">{{'filter.panel.sizes.frames.width' | translate}}</label>
              <p class="error-message" *ngIf="errorFrame">{{'filter.panel.sizes.error.msg' | translate}}</p>
            </div>
          </div>
        </div>
    </div>
    <div class="sizeFilterPanel_footerMobile">
        <ol class="sizeFilterPanel_nav">
          <li [ngClass]="{'-selected': activePanel === 'noseLense'}">
            <button (click)="activePanel = 'noseLense'">1</button>
          </li>
          <li [ngClass]="{'-selected': activePanel === 'frame'}">
            <button (click)="activePanel = 'frame'">2</button>
          </li>
        </ol>
        <div class="sizeFilterPanel_submit">
          <button (click)="newSearch(activePanel)" [disabled]="(!framesName && !noseName && !lensesName) || processing">{{'filter.panel.sizes.button.search' | translate}}</button>
        </div>
        <p class="sizeFilterPanel_toleranceInfo" *ngIf="tolerance > 0">{{'filter.panel.sizes.info' | translate}} {{tolerance}}mm</p>
      </div>
  </div>
</div>
